function toggleMobileMenu(submenuTarget) {
    let menuMobile = document.querySelector('#menuMobile');
    let html = document.querySelector('html');
    let submenu;
    if (submenuTarget) {
        submenu = menuMobile.querySelectorAll(".js-menu-dropdown-parent button");
        // filtrar porque el texto del boton sea igual al submenuTarget
        submenu = Array.from(submenu).filter((item) => {
            let text = item.textContent.trim().toLowerCase();
            return text === submenuTarget.trim().toLowerCase();
        })[0];
    }

    let openMenu = () => {
        menuMobile.classList.add('visible');
        menuMobile.classList.add('active');
        menuMobile.setAttribute("aria-modal","true");
        menuMobile.setAttribute("role","dialog");
        html.style.overflow = 'hidden';
        if (submenuTarget && submenu && submenu.getAttribute('aria-expanded') === 'false'){
            submenu.click();
        }

    }

    let closeMenu = () => {
        menuMobile.classList.remove('visible');
        setTimeout(() => {
            menuMobile.classList.remove('active');
        }, 300);
        menuMobile.removeAttribute("aria-modal");
        menuMobile.removeAttribute("role");
        html.style.overflow = 'auto';
        // buscar submenu abierto y cerrarlo
        let submenuOpened = menuMobile.querySelectorAll(".js-menu-dropdown-parent button[aria-expanded='true']");
        if (submenuOpened.length > 0){
            submenuOpened[0].click();
        }
    }

    if (menuMobile.classList.contains('visible')) {
        closeMenu();
    } else {
        openMenu();
    }
}

window.toggleMobileMenu = toggleMobileMenu;
